<!--
 * @Description: 因为是两列的，并且不规则，不进行计算（目前的调研和可配置，只一页显示）
 * @Date: 2024-01-11 14:07:13
-->
<template>
  <div>
    <div class="t_name">
      <p class="cn">目录</p>
      <p class="en">contents</p>
    </div>
    <p class="detail">
      本报告所依赖数据都来自于线上或线下真实发生的行为所产生的数据，本次用于生成报告的数据为
      {{ taskSum }} 份。
    </p>
    <div class="columns">
      <div
        class="item"
        v-for="({ title, child }, index) in catalogue"
        :key="index"
      >
        <div class="index">{{ `${index + 1}`.padStart(2, '0') }}</div>
        <div class="name">{{ title }}</div>
        <div class="child" v-if="Array.isArray(child)">
          <div
            class="child-item"
            v-for="({ title, num }, childIndex) in child"
            :key="childIndex"
          >
            <p class="child-item-name">{{ title }}</p>
            <p class="child-item-number">
              {{ `${num}`.padStart(2, '0') }}
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="tsx">
import { watch } from 'vue';

type CataLogueType = Array<{
  title: string;
  num: number;
  child: CataLogueType;
}>;
const props = withDefaults(
  defineProps<{ taskSum?: number; catalogue: CataLogueType }>(),
  {
    taskSum: 1
  }
);
const emits = defineEmits(['catalogueFinish']);
watch(
  () => props.catalogue,
  () => {
    emits('catalogueFinish');
  }
);
</script>
<style lang="scss" scoped>
@import './index.scss';
.t_name {
  display: flex;
  align-items: center;
  justify-content: space-between;
  color: #fff;
  font-weight: 500;
  padding-bottom: 12px;
  border-bottom: 6px solid var(--theme-color-1);
  .cn {
    font-size: 45px;
    font-weight: 500;
    color: #0f0f0f;
  }
  .en {
    font-size: 36px;
    text-transform: uppercase;
    color: #797979;
  }
}
.detail {
  font-size: 16px;
  font-weight: 500;
  line-height: 1.6;
  color: #3e3e3e;
  padding-bottom: 60px;
  padding-top: 40px;
}

.columns {
  column-count: 2;
  column-gap: 100px;
}

.item {
  break-inside: avoid-column;
  position: relative;
  &::after {
    content: '';
    width: 100%;
    height: 1pt;
    background-color: #9d9d9d;
    position: absolute;
    left: 0;
    bottom: 32px;
  }
  .index {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 66px;
    height: 66px;
    background-color: var(--theme-color-1);
    font-size: 32px;
    font-weight: 500;
    color: #ffffff;
    $bottom: 9px;
    padding-bottom: $bottom;
    clip-path: polygon(
      0 0,
      100% 0,
      100% calc(100% - $bottom),
      40% calc(100% - $bottom),
      0 100%
    );
  }
  .name {
    font-size: 30px;
    font-weight: 500;
    padding-top: 8px;
    color: #222222;
    @include line_clamp(1);
  }
  .child {
    padding-top: 12px;
    padding-bottom: 48px;
    .child-item {
      display: flex;
      align-items: center;
      justify-content: space-between;
      font-size: 18px;
      font-weight: 500;
      color: #222222;
      padding: 8px 0;
    }
    .child-item-name {
      max-width: 80%;
      @include line_clamp(1);
    }
    .child-item-number {
    }
  }
}
</style>
